import axios from 'axios';

const initialState = {
  positions: [],
  firstName: '',
  lastName: '',
  department: '',
  position: '',
  isd: '',
  school: '',
  email: '',
  phoneNumber: '',
  instrument: '',
  didErr: false
};

const GET_POSITIONS = 'GET_POSITIONS';
const UPDATE_INPUT = 'UPDATE_INPUT';
const RESET = 'RESET';

export function getPositions() {
  return {
    type: GET_POSITIONS,
    payload: axios.get('/api/get-positions')
  };
}

export const updateInput = input => {
  return {
    type: UPDATE_INPUT,
    payload: input
  };
};

export const reset = () => {
  return {
    type: RESET,
    payload: ''
  };
};

export default function locationReducer(state = initialState, action) {
  switch (action.type) {
    case `${GET_POSITIONS}_FULFILLED`:
      return {
        ...state,
        positions: action.payload.data
      };
    case `${GET_POSITIONS}_REJECTED`:
      return {
        ...state,
        didErr: true
      };
    case UPDATE_INPUT:
      return {
        ...state,
        [action.payload.target.name]: action.payload.target.value
      };
    case RESET:
      return {
        ...state,
        firstName: action.payload,
        lastName: action.payload,
        department: action.payload,
        position: action.payload,
        isd: action.payload,
        school: action.payload,
        email: action.payload,
        phoneNumber: action.payload,
        instrument: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/ducks/reducer.js